import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["button", "qrSection", "qrImage", "status"]

  connect() {
    this.orderRef = null
    this.collectTimer = null
  }

  disconnect() {
    this.stopTimers()
  }

  async start() {
    if (this.buttonTarget.disabled) return

    this.stopTimers()
    this.orderRef = null
    this.buttonTarget.disabled = true
    this.buttonTarget.hidden = true
    this.qrSectionTarget.hidden = true
    this.statusTarget.textContent = ""

    try {
      const response = await fetch("auth/bankid", {
        method: "POST",
        headers: {
          "Content-Type": "application/json",
          "X-CSRF-Token": this.csrfToken(),
        },
        body: JSON.stringify({}),
      })

      if (!response.ok) throw new Error("auth_failed")

      const data = await response.json()
      this.orderRef = data.orderRef

      if (this.isMobile()) {
        this.launchBankIdApp(data.autoStartToken)
      }

      this.updateQr(data.qrSvg)
      this.collectTimer = window.setInterval(() => this.pollStatus(), 1000)
      this.pollStatus()
    } catch (error) {
      console.log(error)
      this.statusTarget.textContent = "Kunde inte starta BankID."
      this.qrSectionTarget.hidden = true
      this.buttonTarget.hidden = false
      this.buttonTarget.disabled = false
    }
  }

  launchBankIdApp(autoStartToken) {
    if (!autoStartToken) return

    const bankIdUrl = `bankid:///?autostarttoken=${autoStartToken}&redirect=null`
    window.location.href = bankIdUrl
  }

  isMobile() {
    return /Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i.test(
      navigator.userAgent
    )
  }

  updateQr(svg) {
    if (!svg) return
    this.qrSectionTarget.hidden = false
    this.qrImageTarget.src = `data:image/svg+xml;utf8,${encodeURIComponent(svg)}`
  }

  async pollStatus() {
    if (!this.orderRef) return

    try {
      const response = await fetch(`auth/bankid/status?order_ref=${encodeURIComponent(this.orderRef)}`)
      if (!response.ok) throw new Error("status_failed")

      const data = await response.json()
      this.updateQr(data.qrSvg)
      if (data.status === "pending") return

      if (data.status === "complete") {
        window.location.assign(data.location || "/orders")
      } else {
        this.statusTarget.textContent = "Inloggningen misslyckades. Försök igen."
        this.qrSectionTarget.hidden = true
        this.buttonTarget.hidden = false
        this.buttonTarget.disabled = false
      }

      this.stopTimers()
    } catch (error) {
      this.statusTarget.textContent = "Kunde inte läsa BankID-status."
      this.stopTimers()
      this.qrSectionTarget.hidden = true
      this.buttonTarget.hidden = false
      this.buttonTarget.disabled = false
    }
  }

  stopTimers() {
    if (this.collectTimer) window.clearInterval(this.collectTimer)
    this.collectTimer = null
  }

  csrfToken() {
    const meta = document.querySelector("meta[name='csrf-token']")
    return meta ? meta.content : ""
  }
}
